import {SelectedFile} from "core/transfer/selection";

/**
 * Identity for selection dedup (ui#94): the FULL relative path when the file came from a folder
 * (so `docs/report.pdf` and `img/report.pdf` coexist), the leaf name when flat — plus size and
 * last-modified time (the pre-folder key, unchanged for pathless files).
 */
function sameSelection(a: SelectedFile, b: SelectedFile): boolean {
	return (a.relativePath ?? a.file.name) === (b.relativePath ?? b.file.name)
		&& a.file.size === b.file.size
		&& a.file.lastModified === b.file.lastModified;
}

/**
 * Merge newly added selection entries into the existing ones, de-duplicating by path (see
 * {@link sameSelection}). Incoming entries come first (most recently chosen on top), matching the
 * prior SuperDropzone behavior.
 */
export function mergeSelectedFiles(existing: SelectedFile[], incoming: SelectedFile[]): SelectedFile[] {
	const merged = [...incoming];
	for (const entry of existing) {
		if (!merged.some(candidate => sameSelection(candidate, entry))) {
			merged.push(entry);
		}
	}
	return merged;
}

/**
 * Pathless convenience over {@link mergeSelectedFiles} (the pre-ui#94 contract): plain `File`s
 * merge by name + size + last-modified time exactly as before.
 */
export function mergeFiles(existing: File[], incoming: File[]): File[] {
	const wrap = (files: File[]) => files.map(file => ({file}));
	return mergeSelectedFiles(wrap(existing), wrap(incoming)).map(entry => entry.file);
}
